import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { shareReplay, switchMap, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class KeyService {
  private tokenSubject = new BehaviorSubject<string | null>(null);
  private tokenRequest: Observable<string> | null = null;

  constructor(private http: HttpClient) { }

  private fetchToken(): Observable<string> {
    // alert('fetching token from server...');
    return this.http.post<{ icjs: string }>(environment.API_URL + '/auth/pc/', {}).pipe(
      tap(res => {
        this.tokenSubject.next(res.icjs);
      }),
      switchMap(res => of(res.icjs))
    );
  }

  // private fetchToken(): Observable<string> {
  //   const mockToken = "A8dVGtmELp!3&nQ7";
  //   this.tokenSubject.next(mockToken);
  //   return of(mockToken);
  // }


  getToken(): Observable<string> {
    return this.tokenSubject.pipe(
      switchMap(token => {
        return of(token as string);
      })
    );
  }

  initializeToken(): Observable<string> {
    this.tokenRequest ??= this.fetchToken().pipe(
      shareReplay({ bufferSize: 1, refCount: false })
    );
    return this.tokenRequest;
  }
}
